import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const muiV37Gray50 = '#F8F8F8';
const muiV37Gray200 = '#DDDEDE';
const muiV37Blurple700 = '#4B3FFF';

export const styles = createTypedSxStyles({
  baseSelectedFileContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: muiV37Gray50,
    border: `1px solid ${muiV37Gray200}`,
    borderRadius: '4px',
    padding: '8px'
  },
  defaultSelectedFileContainer: {
    border: `1px solid ${muiV37Gray200}`,
    marginBottom: '4px'
  },
  errorSelectedFileContainer: {
    border: `1px solid ${capitalDesignTokens.foundations.colors.red700}`
  },
  title: {
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.medium,
    marginBottom: '4px'
  },
  fileInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  },
  fileName: {
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.medium,
    color: capitalDesignTokens.foundations.colors.gray800
  },
  excelIcon: {
    width: '24px',
    height: '24px',
    color: '#4CAF50' // Excel green color
  },
  reUploadButton: {
    color: muiV37Blurple700,
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold,
    '&:hover': {
      backgroundColor: capitalDesignTokens.foundations.colors.brand50
    },
    '& .MuiButton-startIcon svg': {
      height: '24px',
      width: '24px'
    }
  },
  reUploadButtonErrorState: {
    color: capitalDesignTokens.foundations.colors.white
  },
  errorMessageContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginTop: '4px'
  },
  errorIcon: {
    width: '16px',
    height: '16px',
    color: capitalDesignTokens.foundations.colors.red700
  },
  errorMessage: {
    color: capitalDesignTokens.foundations.colors.red700
  }
});
